import axios from "axios";
import { showToast } from "../utils/libs/toast-utilis";
import { decryptData, encryptData } from "../utils/libs/crypto";

function getAuthToken() {
  const getCustomerDetails = localStorage?.getItem("authDetails");
  const customerDetailsPares = getCustomerDetails
    ? JSON.parse(getCustomerDetails)
    : {};
  return customerDetailsPares?.token;
}

export function apiClient({
  url,
  data,
  method = "POST",
  headers = {},
  noHeaders = false,
  encrypt = true,
  decrypt = true,
  ...rest
}) {
  const token = getAuthToken();

  const finalHeaders = noHeaders
    ? {}
    : {
        ...headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "application/json",
      };
  const payload = encrypt ? { encryptedPayload: encryptData(data) } : data;
  const config = {
    method,
    url,
    data: payload,
    headers: finalHeaders,
    ...rest,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        const result =
          decrypt && res?.data?.encryptedPayload
            ? decryptData(res.data.encryptedPayload)
            : res.data;
        resolve(result);
      })
      .catch((err) => {
        const result =
          decrypt && err?.response?.data?.encryptedPayload
            ? decryptData(err?.response?.data?.encryptedPayload)
            : err?.response?.data;
        if (err?.response?.status === 401) {
          localStorage.clear();
          showToast.error("Unauthorized access. You have been logged out.");
        }
        reject({ ...err, response: { ...err?.response, data: result } });
      });
  });
}
